<template>
  <div
    v-show="isPopupVisible"
    ref="notificationPopup"
    :class="clsx('notification-popup', { 'notification-popup--visible': isPopupVisible })"
    role="dialog"
    :aria-hidden="!isPopupVisible"
    @click="() => closePopup(this.getPopupId)"
  >
    <slot />
  </div>
</template>

<script>
import clsx from 'clsx';
import { popupView } from '../../lib';

export default {
  mixins: [ popupView ],
  created() {
    this.$eventBus.$on('popup-close', this.closePopup);
  },
  beforeDestroy() {
    this.$eventBus.$off('popup-close', this.closePopup);
  },
  methods: { clsx },
};
</script>

<style scoped lang="scss">
.notification-popup {
  font-family: "Geist", sans-serif;
  font-size: 14px;
  color: #09090B;
  display: none;
  z-index: 100;

  &--visible {
    display: block;

    @media (max-width: 550px) {
      right: 24px !important;
      left: 24px !important;
    }
  }
}
</style>
